import styled from 'styled-components'
import { bp, font } from 'lib/core/resources/helpers/styled'

export const Container = styled.div`
  ${props => props.theme.css.container};
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  background: ${props => props.theme.palette.primary.beta};
  z-index: 999;
  border-radius: 7px 7px 0 0;
`

export const Heading = styled.div<any>`
  padding: 15px 5%;
  font: ${font('default', 'bold', '20px/1.5')};
  color: ${props => props.theme.palette.general.light};
  display: flex;
  align-items: center;
  cursor: pointer;

  svg {
    width: 18px;
    height: 24px;
    margin-left: 25px;
    fill: ${props => props.theme.palette.general.light};
    transform: ${(props: any) => !props.isOpen && 'rotate(180deg)'};
  }
`

export const Content = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 20px 5% 40px;
  ${bp('sm')`
    flex-wrap: wrap;
  `}

  > div {
    width: 26%;
    background-color: ${props => props.theme.palette.primary.alpha};
    text-align: center;
    padding: 15px;
    border-radius: 5px;
    text-transform: uppercase;
    margin: 0 5px;
    ${bp('sm')`
      width: 100%;
      margin-bottom: 15px;
    `}

    h2 {
      font: ${font('default', 'bold', '16px/1.2')};
      color: ${props => props.theme.palette.general.light};
      margin: 0;
    }

    a {
      background: ${props => props.theme.palette.primary.alphaDark};
      color: ${props => props.theme.palette.general.light};
      font: ${font('default', 'bold', '12px/1.5')};
      display: block;
      margin: 6px auto;
      text-decoration: none;
      max-width: 70%;
      padding: 5px;
      border-radius: 8px;
      transition: all ease-in-out 0.3s;
      ${bp('sm')`
        width: 70%;
        max-width: 240px;
      `}

      &:hover {
        opacity: 0.8;
      }
    }
  }
`
